import { render, staticRenderFns } from "./agreement-user.vue?vue&type=template&id=66a90cde&scoped=true";
import script from "./agreement-user.vue?vue&type=script&lang=js";
export * from "./agreement-user.vue?vue&type=script&lang=js";
import style0 from "./agreement-user.vue?vue&type=style&index=0&id=66a90cde&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "66a90cde", null);
export default component.exports;